import { TwoColumnLayout } from 'layouts';
import type { ReactNode } from 'react';

type P = {
  left: ReactNode;
  right: ReactNode;
};

const MemberContentLayout = ({ left, right }: P) => (
  <TwoColumnLayout left={left} leftOptions={{ offsetTop: 'default', widthMode: 'small' }} right={right} />
);

export default MemberContentLayout;
